import { usePreference } from "../../hooks/preference/usePreference";
import { DefaultPreferenceOptions } from "../../constants/userPreference";
import { TimeFormatOption } from "../../types/account/enum";

export function MyTimeGutterWrapper({ localizer, slotMetrics }) {
  const { preference: userPreference } = usePreference();
  const timeFormat = userPreference?.timeFormat ?? DefaultPreferenceOptions.timeFormat;
  return (
    <div className="rbc-time-gutter rbc-time-column">
      {slotMetrics.groups.map((date, idx) => {
        return (
          <div
            className="rbc-timeslot-group"
            key={`${date[0]}${idx}`}
          >
            <div className="rbc-label">
              {idx > 0 &&
                localizer.format(
                  new Date(date[0]),
                  timeFormat === TimeFormatOption.HOUR12 ? "h a" : "HH" + ":" + "00"
                )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
